import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: () => import("../views/Products"),

    name: "products",
    redirect: { name: "autoReg" },
    children: [
      {
        path: "products/shop-center",
        component: () => import("../views/ShopCenters"),
        meta: { path: 1, key: 1, id: 1 },
        name: "shop-center",
        redirect: { name: "autoReg" },
        children: [
          {
            path: "auto-registration",
            component: () => import("../views/AutoReg"),
            meta: { path: 1, key: 1, index: 1, id: 2 },
            name: "autoReg",
          },
          {
            path: "independ-registration",
            component: () => import("../views/IndependReg"),
            meta: { path: 1, key: 1, index: 2, id: 3 },
            name: "independReg",
          },
          {
            path: "loyality-program",
            component: () => import("../views/ProgramLoyal"),
            meta: { path: 1, key: 1, index: 3, id: 4 },
            name: "loyalProgram",
          },
        ],
      },
      {
        path: "products/brands",
        component: () => import("../views/Brands"),
        meta: { path: 1, key: 2, id: 5 },
        name: "brands",
      },
      {
        path: "products/franchisors",
        component: () => import("../views/Franchisors"),
        meta: { path: 1, key: 3, id: 6 },
        name: "franchisors",
      },
    ],
  },
  {
    path: "/blog",
    component: () => import("../views/Blog"),

    name: "blog",
    meta: { path: 2, key: "blog", id: 7 },
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router
